/**
 * Route helpers for Inky: which editor (if any) a URL is, as a stable context key.
 *
 * Handles the in-app workspace route `/documents/:documentId/edit` (CONTRACTS-W2 §A) as well as
 * the legacy `/editor?documentId=` and template editor routes (src/utils/editorRouteContext.js),
 * so a document keeps ONE Inky conversation whichever route opened it.
 */

import { getEditorSessionKey } from "../utils/editorRouteContext";

/** `/documents/:documentId/edit` (optionally with a trailing slash). */
const WORKSPACE_DOCUMENT_ROUTE = /^\/documents\/([^/]+)\/edit\/?$/;

/**
 * Document id of the in-app workspace route, or null.
 * @param {string} pathname - location.pathname.
 * @returns {string|null} Document id.
 */
export const workspaceDocumentId = (pathname) => {
  const match = WORKSPACE_DOCUMENT_ROUTE.exec(String(pathname || ""));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

/**
 * Editor context key for a route (`editor-doc:<id>` / `editor-template:<id>`), or null.
 * @param {string} pathname - location.pathname.
 * @param {string} search - location.search.
 * @returns {string|null} Context key.
 */
export const editorContextKey = (pathname, search) => {
  const documentId = workspaceDocumentId(pathname);
  if (documentId && documentId !== "new") return `editor-doc:${documentId}`;
  return getEditorSessionKey(String(pathname || ""), String(search || ""));
};
